const MENU_READER_STATUS = Object.freeze({
  active: 'active',
  ordered: 'ordered',
  deleted: 'deleted',
  missing: 'none',
});

// noinspection JSUnusedGlobalSymbols
export default MENU_READER_STATUS;
